import { ProjectTypes } from '@platform/types';
import React from 'react';
import AnalysisPanelSelectionTools from './SelectionTools/AnalysisPanelSelectionTools';
import SurveyAnalysis from './Survey/SurveyAnalysis';

interface Props {
  mapObj: ProjectTypes.MapObject;
}

const AnalysisPanel: React.FC<Props> = ({ mapObj }) => {
  const { styleSpec } = mapObj;
  const { workingLayers } = styleSpec;

  const handleStyleUpdate = (newMapStyle: ProjectTypes.MapSpec) => {
    mapObj.updateMapSpec(newMapStyle);
  };

  return (
    <div className="flex flex-col gap-2">
      {mapObj.ref && (
        <AnalysisPanelSelectionTools map={mapObj.ref} styleSpec={mapObj.styleSpec} onStyleUpdate={handleStyleUpdate} />
      )}
      <div className="-mx-6 h-[1px] border-b" />
      <div className="flex flex-col gap-4">
        {workingLayers
          .filter((x) => x.source === 'social-explorer')
          .map((workingLayer) => (
            <div key={workingLayer.id} className="flex flex-col">
              <SurveyAnalysis workingLayer={workingLayer as ProjectTypes.SocialExplorerWorkingLayer} />
              <div className="-mx-6 h-[1px] border-b" />
            </div>
          ))}
      </div>
    </div>
  );
};

export default AnalysisPanel;
